import CustomFields from './CustomFieldsContainer';

export default CustomFields;
